import { render, staticRenderFns } from "./Mipay.vue?vue&type=template&id=683d422b&scoped=true&"
import script from "./Mipay.vue?vue&type=script&lang=js&"
export * from "./Mipay.vue?vue&type=script&lang=js&"
import style0 from "./Mipay.vue?vue&type=style&index=0&id=683d422b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d422b",
  null
  
)

export default component.exports